import * as tracking from 'dibs-tracking';
import serverVars from 'server-vars';

const GET_HELP_CATEGORY = 'Contact 1stDibs';
const CONTACT_DEALER_CATEGORY = 'contact dealer';

import { PlacementOptions } from './types';
import { Step } from './types';

export const trackNavigateToMC = (): void =>
    tracking.trackEvent({
        category: CONTACT_DEALER_CATEGORY,
        action: 'get help contact seller click',
    });

export const trackUserMessage = (): void =>
    tracking.trackEvent({
        category: CONTACT_DEALER_CATEGORY,
        action: 'contact dealer submitted',
        label: 'get help embedded contact',
    });

export const trackCategorySelect = (categoryKey: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'category selected',
        label: categoryKey,
    });
};

export const trackTopicSelect = (topicKey: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'topic selected',
        label: topicKey,
    });
};

export const trackSubmit = (topicKey: string | null): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'submitted message',
        label: topicKey,
    });
};

export const trackGetHelpOpened = (placement: PlacementOptions): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'support modal opened',
        label: placement,
    });
};

export const trackChatInitiated = (topicKey: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'chat initiated',
        label: topicKey,
    });
};

export const trackSMSClick = (topicKey: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'support SMS click',
        label: topicKey,
    });
};

export const trackWhatsAppClick = (topicKey: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'support WhatsApp click',
        label: topicKey,
    });
};

export const chatCtaDisplayed = (isAgentAvailable: boolean): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'chat CTA displayed',
        label: `agents ${isAgentAvailable ? 'online' : 'offline'}`,
    });
};

export const trackContactSeller = (topicKey?: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'get help contact seller',
        label: topicKey || '',
    });
};

export const trackPrimaryCtaClick = (topicKey: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'primary CTA click',
        label: topicKey,
    });
};

export const trackSupportCenterClick = (topicKey: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'support center click',
        label: topicKey,
    });
};

export const trackGoBackNav = (step: Step): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'go back',
        label: step,
    });
};

export const existingChatLoaded = (): void => {
    const pageType = serverVars.get('settings.pageType');

    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'existing chat loaded',
        label: pageType,
    });
};

export const trackHelpWithAnOrderClick = (): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'help with an order clicked',
    });
};

export const trackContactOptionsExpanded = (topicKey?: string): void => {
    tracking.trackEvent({
        category: GET_HELP_CATEGORY,
        action: 'contact options expanded',
        label: topicKey || '',
    });
};
